import PropTypes from 'prop-types';
import React, {Component} from 'react';
import moment from 'moment';

// Components
import ProgressNode from './progress_node';

class ProgressBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentState: props.progress.progress
        };
    }

    handleRenewButtonClick = e => {
        e.preventDefault();
        window.location = window.sn.campaignRenewUrl;
    };

    render() {
        const progressState = window.sn.progressStatuses;
        const {fullStartDate, fullEndDate} = this.props;
        const startDate = moment(new Date(fullStartDate)).format('M/D');
        const endDate = moment(new Date(fullEndDate)).format('M/D');

        return (
            <div className="panel panel-default panel-campaign-progress">
                <div className="row row-campaign-progress">
                    <div className="campaign-progress-header">Campaign Progress</div>
                    <div className="campaign-progress-body">
                        <ul className="campaign-progress-list">
                            <ProgressNode
                                currentState={this.state.currentState}
                                progressState={progressState.CREATED}
                                activeBackgroundUrl={
                                    '/images/admin/campaign_analytics/progress1.png'
                                }
                                inactiveBackgroundUrl={
                                    '/images/admin/campaign_analytics/progress1.png'
                                }
                                subtitle="Order Placed"
                            />
                            <ProgressNode
                                currentState={this.state.currentState}
                                progressState={progressState.INVITES_SENT}
                                activeBackgroundUrl={
                                    '/images/admin/campaign_analytics/progress2.png'
                                }
                                inactiveBackgroundUrl={
                                    '/images/admin/campaign_analytics/progress2_inactive.png'
                                }
                                subtitle="Creators Invited"
                            />
                            <ProgressNode
                                currentState={this.state.currentState}
                                progressState={progressState.INVITES_ACCEPTED}
                                activeBackgroundUrl={
                                    '/images/admin/campaign_analytics/progress3.png'
                                }
                                inactiveBackgroundUrl={
                                    '/images/admin/campaign_analytics/progress3_inactive.png'
                                }
                                subtitle="Creators Accepted"
                            />
                            <ProgressNode
                                currentState={this.state.currentState}
                                progressState={progressState.STARTED}
                                activeBackgroundUrl={
                                    '/images/admin/campaign_analytics/progress4.png'
                                }
                                inactiveBackgroundUrl={
                                    '/images/admin/campaign_analytics/progress4_inactive.png'
                                }
                                subtitle={`Posts Live ${startDate}`}
                            />
                            <ProgressNode
                                currentState={this.state.currentState}
                                progressState={progressState.ENDED}
                                activeBackgroundUrl={
                                    '/images/admin/campaign_analytics/progress5.png'
                                }
                                inactiveBackgroundUrl={
                                    '/images/admin/campaign_analytics/progress5_inactive.png'
                                }
                                subtitle={`Ends ${endDate}`}
                            />
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

ProgressBar.propTypes = {
    progress: PropTypes.shape({
        progress: PropTypes.number.isRequired,
        show_tracker: PropTypes.bool.isRequired
    }).isRequired,
    fullStartDate: PropTypes.string.isRequired,
    fullEndDate: PropTypes.string.isRequired
};

export default ProgressBar;



// WEBPACK FOOTER //
// ./campaign_analytics/v2/campaign_analytics_page/progress_bar/index.js